import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaTimes } from 'react-icons/fa';

export default function ImageViewer({ isOpen, onClose, imageUrl, alt }) {
  // Handle ESC key press
  useEffect(() => {
    const handleEscKey = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      window.addEventListener('keydown', handleEscKey);
    }

    return () => {
      window.removeEventListener('keydown', handleEscKey);
    };
  }, [isOpen, onClose]);

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/90"
          onClick={onClose} // Close on backdrop click
        >
          {/* Close Button */}
          <button
            onClick={(e) => {
              e.stopPropagation(); // Prevent event from reaching backdrop
              onClose();
            }}
            className="absolute top-4 right-4 p-3 text-white hover:text-red-500 
                     transition-colors bg-black/20 rounded-full backdrop-blur-sm z-[60]"
            aria-label="Close modal"
          >
            <FaTimes className="w-6 h-6" />
          </button>

          {/* Image Container */}
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            className="relative max-w-[95vw] max-h-[95vh]"
            onClick={(e) => e.stopPropagation()} // Prevent clicks on image from closing
          >
            <img
              src={imageUrl}
              alt={alt}
              className="w-full h-full object-contain rounded-lg"
              draggable="false"
            />
          </motion.div>

          {/* Mobile instruction */}
          <div className="absolute bottom-8 left-0 right-0 text-center">
            <p className="text-white/75 text-sm">
              Tryk uden for billedet for at lukke.
            </p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}